import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	statusCode: number
}

export const StatusCode = styled.code.attrs<Props>(({ statusCode }) => ({
	children: statusCode,
}))<Props>`
	font-weight: 500;
	color: ${({ statusCode }) => {
		if (statusCode < 300) return helpers.color.success
		if (statusCode < 400) return helpers.color.link
		if (statusCode >= 400) return helpers.color.error
	}};
`
